import React, { useContext, useEffect, useState } from "react";
import "./SourceRefresh.scss";
import MultiSelect from "../MultiSelect/MultiSelect";
import ReactSelect from "react-select";
import { useGetPointingNamesQuery, useGetSPWSByPointingAndBandMutation } from "../../redux/catalogueService";
import { useParams } from "react-router-dom";
import { useBulkRefreshSourcesMutation } from "../../redux/pointingSourcesService";
import { AppContext } from "../../context/appContext";
import { tranformOptionsForRequest } from "../../helperFunc";


const multiselectDrodpowns = [
  {
    name: "Pointing",
    key: "pointing_multi_select",
    isMulti: true,
  },
  {
    name: "Band",
    key: "pointing_multi_select",
    isMulti: false,
  },
  {
    name: "SPW",
    key: "spw_multi_select",
    isMulti: true,
  },
];
const bandOptions = [
  { value:  "L", label: "L" },
  { value:  "U" , label: "U" },

];


function SourceRefresh() {
  const {catalogueMetadataId:catalogueId}=useParams();
  const [menuOpen,setIsMenuOpen]=useState({
    pointing:false,
    spw:false
  })
  const {data:pointing_names} =useGetPointingNamesQuery(catalogueId);
  const [getSpwsByPointingAndBand]=useGetSPWSByPointingAndBandMutation();
  const [triggerBulkRefresh, {isLoading: isBulkRefreshLoading}] = useBulkRefreshSourcesMutation();
  const { toggleLoaderVisibility,showFlyout } = useContext(AppContext);

  const [optionSelected, setSelected] = useState({
    pointing: [],
    band: bandOptions[0],
    spw: [],
  });
  const [multiselectSortedList, setMultiselectSortedList] = useState({
    pointing: [],
    band: bandOptions,
    spw: [],
  });
  const [displayOptions, setDisplayOptions] = useState({
    pointing: [],
    band: bandOptions,
    spw: [],
  });

  useEffect(() => {
    if (
     isBulkRefreshLoading
    ) {
      toggleLoaderVisibility(true);
    } else {
      toggleLoaderVisibility(false);
    }
  }, [
    isBulkRefreshLoading
  ]);

  useEffect(()=>{
    setDisplayOptions(prev=>{
      return {
        ...prev,
        pointing:pointing_names
      }
    })
    setMultiselectSortedList(prev=>{
      return {
        ...prev,
        pointing:pointing_names
      }
    })
    setSelected(prev=>{
      return {
        ...prev,
        pointing:pointing_names
      }
    })
  },[pointing_names])

  async function  getSPWS(){

    const result =await getSpwsByPointingAndBand({
      catId:catalogueId,
      filterData:{
        pointing_names:tranformOptionsForRequest(optionSelected.pointing),
        obs_band:optionSelected.band.value
      }
    });
    setDisplayOptions(prev=>{
      return {
        ...prev,
        spw:result?.data
      }
    })
    setMultiselectSortedList(prev=>{
      return {
        ...prev,
        spw:result?.data
      }
    })
    setSelected(prev=>{
      return {
        ...prev,
        spw:result?.data
      }
    })
  }

  useEffect(()=>{
    if(!optionSelected?.pointing ||  displayOptions?.pointing?.length===0) return;
    getSPWS();
  },[optionSelected.pointing,optionSelected.band,pointing_names]);

  const handleChange = (selectedItems, items, dropdownName) => {
    setSelected((prev) => {
      return {
        ...prev,
        [dropdownName]: selectedItems,
      };
    });
    const unselectedItems = items.filter(
      (selectedItem) =>
        !selectedItems?.find((item) => item.label === selectedItem.label)
    );

    setMultiselectSortedList((prev) => {
      return {
        ...prev,
        [dropdownName]: [...unselectedItems, ...selectedItems],
      };
    });
  };

  const handleBlur = (dropdownName) => {
    setDisplayOptions(multiselectSortedList);
  };
  const onMenuClose=(dropdownName)=>{
    handleBlur();
    setIsMenuOpen(prev=>{
    return {  ...prev,
      [dropdownName]: false
    }
    });
  }

  const onMenuOpen=(dropdownName)=>{
    setIsMenuOpen(prev=>{
    return {  ...prev,
      [dropdownName]: true
    }
    });
  }

  const triggerBulkSourceRefresh=async () => {
    let refreshOptions={
      pointing_names: tranformOptionsForRequest(optionSelected.pointing),
      obs_band: optionSelected.band.value,
      spw: tranformOptionsForRequest(optionSelected.spw),
    };
  const result= await  triggerBulkRefresh({refreshOptions,catalogueId})

  if(result?.error){
    showFlyout(`ERROR: ${result?.error?.data?.message}`)
  }
  else {
    showFlyout(`Bulk upload in progress. Check History for more updates`);
  }


}
  if(!displayOptions.pointing || displayOptions.pointing.length===0) return;
  return (
    <div className="multi-select-container">
      <div className="multiselect-options">
        {multiselectDrodpowns.map((dropdown) => (
          <div>
            <label htmlFor={dropdown.name.toLowerCase()}>{dropdown.name}</label>
            {dropdown.isMulti ? (
              <MultiSelect
                id={dropdown.name.toLowerCase()}
                isMulti={dropdown.isMulti}
                key={dropdown.key}
                options={displayOptions[dropdown.name.toLowerCase()]}
                onChange={(selected) =>
                  handleChange(
                    selected,
                    displayOptions[dropdown.name.toLowerCase()],
                    dropdown.name.toLowerCase()
                  )
                }
                value={optionSelected[dropdown.name.toLowerCase()]}
                isSelectAll={dropdown.isMulti}
                menuPlacement={"bottom"}
                closeMenuOnSelect={false}
                onBlur={handleBlur}
                tabSelectsValue={false}
                hideSelectedOptions={false}
                backspaceRemovesValue={false}
                blurInputOnSelect={true}
                isClearable
                isSearchable
                onMenuClose={()=>onMenuClose(dropdown.name.toLowerCase())}
                onMenuOpen={()=>onMenuOpen(dropdown.name.toLowerCase())}
                // menuIsOpen={true}
                controlShouldRenderValue={!menuOpen[dropdown.name.toLowerCase()]}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? "grey" : "red",
                  }),
                  menubar: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "auto",
                    minWidth: "400px",
                  }),
                }}
              />
            ) : (
              <ReactSelect
                id={dropdown.name.toLowerCase()}
                isMulti={dropdown.isMulti}
                key={dropdown.key}
                options={displayOptions[dropdown.name.toLowerCase()]}
                onChange={(selected) => setSelected((prev)=>{
                  return {
                    ...prev,
                    band:selected
                  }
                })}
                value={optionSelected[dropdown.name.toLowerCase()]}
                menuPlacement={"bottom"}
                closeMenuOnSelect={false}
                tabSelectsValue={false}
                hideSelectedOptions={false}
                backspaceRemovesValue={false}
                blurInputOnSelect={true}
                isSearchable
              />
            )}
          </div>
        ))}
      </div>
      <button
        className="bulk-refresh-btn bg-green-button"
        onClick={triggerBulkSourceRefresh}
      >
        Refresh Data
      </button>
    </div>
  );
}

export default SourceRefresh;
